<template>
  <div class="app-container">
    <el-card>
      <div class="flex-col gap10">
        <div class="flexs gap10 relative items-normal" v-if="info">
          <div class="common-box order-info">
            <div class="status-bar flexs">
              <div class="">
                <span class="status-label">状态：</span>
                <span class="status-value" :class="'status-' + (info.state != null ? info.state : info.auditStatus || info.status)">{{ invoiceStateText(info) || getStatusText(info) }}</span>
              </div>
              <div class="">
                <span class="amount-label">开票金额：</span>
                <span class="amount-value">{{ formatAmount(info.totalPrice || info.invoiceAmount || info.applyAmount) }}</span>
              </div>
            </div>
            <!-- 申请人信息（开票人） -->
            <div class="section-title">申请人</div>
            <div class="applicant-info">
              <div class="detail-item">
                <span class="label">申请人：</span>
                <span class="value">{{ info.name || info.applicantName || info.applicant || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">身份：</span>
                <span class="value">{{ info.identity || info.applicantLevelName || info.applicantIdentity || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">手机号：</span>
                <span class="value">{{ info.pho || info.applicantMobile || info.applicantPhone || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">城市公司：</span>
                <span class="value">{{ info.cityName || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="common-box workflow-steps">
            <div class="step-item" :class="{ active: getStepActive(1) }">
              <div class="item-icon">
                <img v-if="getStepActive(1)" src="@/assets/ok.png" alt="">
              </div>
              <div class="item-title">申请提交</div>
              <div class="item-description">{{ info.createTime || info.createdTime || '-' }}</div>
            </div>
            <div class="step-item" :class="{ active: getStepActive(2) }" v-if="info.state === 1 || info.state === 2">
              <div class="item-icon">
                <img v-if="getStepActive(2)" src="@/assets/ok.png" alt="">
              </div>
              <div class="item-title">待审核</div>
              <div class="item-description" v-if="info.auditName">审核人：{{ info.auditName }}</div>
              <div class="item-description">{{ info.auditTime || '-' }}</div>
            </div>
            <div class="step-item" :class="{ active: getStepActive(3) }" v-if="info.state === 2 || info.state === 1">
              <div class="item-icon">
                <img v-if="getStepActive(3)" src="@/assets/ok.png" alt="" >
              </div>
              <div class="item-title">开票中</div>
              <!-- <div class="item-description">{{ info.auditTime || '-' }}</div> -->
            </div>
            <div class="step-item" :class="{ active: getStepActive(4) }" v-if="info.state === 1 || info.state === 2">
              <div class="item-icon">
                <img v-if="getStepActive(4)" src="@/assets/ok.png" alt="">
              </div>
              <div class="item-title">开票完成</div>
              <div class="item-description">{{ info.invoiceTime || '-' }}</div>
            </div>
            <div class="step-item" :class="{ active: getStepActive(4) }" v-if="info.state === 3">
              <div class="item-icon">
                <img v-if="getStepActive(4)" src="@/assets/fail.png" alt="">
              </div>
              <div class="item-title">开票失败</div>
              <div class="item-description" v-if="info.auditName">审核人：{{ info.auditName }}</div>
              <div class="item-description">{{ info.auditTime || '-' }}</div>
            </div>
          </div>
          <div class="back-list" @click="handleBack">返回列表</div>
        </div>
        <!-- 发票文件（如有） -->
        <div class="common-box" v-if="info && Number(info.state) === 2">
          <invoice-files :invoice-id="getInvoiceId()" />
        </div>
        <!-- 开票信息 -->
        <div class="common-box" v-if="info">
          <div class="common-title">开票信息</div>
          <div class="detail-box">
            <div class="detail-item">
              <span class="label">发票类型：</span>
              <span class="value">{{ info.type || info.invoiceType || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">发票内容：</span>
              <span class="value">{{ info.invoiceContent || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">抬头名称：</span>
              <span class="value">{{ info.title || info.headerName || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">抬头类型：</span>
              <span class="value">{{ info.titleType || info.headerType || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">购买方税号：</span>
              <span class="value">{{ info.taxid || info.taxNo || info.idCard || info.companyTaxNo || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">开票金额：</span>
              <span class="value">{{ formatAmount(info.totalPrice || info.invoiceAmount || info.applyAmount) }}</span>
            </div>
            <div class="detail-item" v-if="info.bankDeposit">
              <span class="label">开户行：</span>
              <span class="value">{{ info.bankDeposit }}</span>
            </div>
            <div class="detail-item" v-if="info.bankNo">
              <span class="label">银行账号：</span>
              <span class="value">{{ info.bankNo }}</span>
            </div>
            <div class="detail-item" v-if="info.registerAddr">
              <span class="label">注册地址：</span>
              <span class="value">{{ info.registerAddr }}</span>
            </div>
            <div class="detail-item" v-if="info.registerPho">
              <span class="label">注册电话：</span>
              <span class="value">{{ info.registerPho }}</span>
            </div>
            <div class="detail-item">
              <span class="label">申请时间：</span>
              <span class="value">{{ info.createTime || info.createdTime || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">审核时间：</span>
              <span class="value">{{ info.auditTime || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">开票时间：</span>
              <span class="value">{{ info.invoiceTime || '-' }}</span>
            </div>
          </div>
        </div>
        <!-- 开票订单信息 -->
        <div class="common-box" v-if="info">
          <div class="common-title">开票订单信息</div>
          <div class="detail-box">
            <div class="detail-item">
              <span class="label">订单编号：</span>
              <span class="value">{{ info.ordernum || info.orderNo || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">订单类型：</span>
              <span class="value">{{ info.ordertype || info.orderType || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">订单状态：</span>
              <span class="value">{{ info.orderstate || info.orderStatus || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">下单时间：</span>
              <span class="value">{{ info.orderTime || info.createTime || info.createdTime || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">付款方式：</span>
              <span class="value">{{ info.orderPayTypeStr || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">付款金额：</span>
              <span class="value" style="white-space: pre-line;">{{ info.payDetail || (info.allPayMoney != null ? formatAmount(info.allPayMoney) : '-') }}</span>
            </div>
            <div class="detail-item">
              <span class="label">付款时间：</span>
              <span class="value">{{ info.payTime || '-' }}</span>
            </div>
          </div>
          <div class="product-table" v-if="getProductList(info).length > 0">
            <el-table :data="getProductList(info)" border size="small">
              <el-table-column label="商品名称" prop="goodsName" min-width="120" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.goodsName || row.productName || '-' }}</template>
              </el-table-column>
              <el-table-column label="图片" align="center" width="80">
                <template slot-scope="{ row }">
                  <el-image v-if="row.goodsUrl || row.productImg || row.image" style="width: 50px; height: 50px;"
                            :src="row.goodsUrl || row.productImg || row.image"
                            :preview-src-list="[row.goodsUrl || row.productImg || row.image]" />
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <!-- REQ-2026-234328：只保留这一列（推给开票平台/用友的就是 goodsSpec）。
                   旧的「商品规格」列取 goodsSkuName||spec，与本列同维度且这套系统 SKU 组合名
                   全是「无规格值」，并排显示只会制造矛盾，已删；为空时回落到旧取值。 -->
              <el-table-column label="产品规格" width="120" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.goodsSpec || row.goodsSkuName || row.spec || '-' }}</template>
              </el-table-column>
              <el-table-column label="数量" align="center" width="80">
                <template slot-scope="{ row }">{{ row.goodsCount != null ? row.goodsCount : (row.quantity || '-') }}</template>
              </el-table-column>
              <el-table-column label="开票金额" align="center" width="100">
                <template slot-scope="{ row }">{{ formatInvoiceLineAmount(row.invoiceLineAmount) }}</template>
              </el-table-column>
              <!-- <el-table-column label="含税总价" align="center" width="100">
                <template slot-scope="{ row }">{{ formatAmount(row.goodsTotalPrice != null ? row.goodsTotalPrice : (row.goodsPrice || row.invoiceAmount || row.amount)) }}</template>
              </el-table-column> -->
            </el-table>
            <div class="table-summary">
              <div class="summary-item">总数量：<span class="summary-value">{{ info.goodsCount != null ? info.goodsCount : getTotalQuantity(info) }}</span></div>
              <div class="summary-item">总金额：<span class="summary-value">{{ formatAmount(info.totalPrice != null ? info.totalPrice : getTotalAmount(info)) }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import invoiceApplicationAuditApi from '@/api/finance/invoiceApplicationAudit'
import InvoiceFiles from './InvoiceFiles.vue'
import { formatInvoiceLineAmount, invoiceStateText } from './manualInvoice'

export default {
  components: { InvoiceFiles },
  props: {
    rowId: { type: [String, Number], default: null },
    rowData: { type: Object, default: null }
  },
  data() {
    return {
      info: null
    }
  },
  watch: {
    rowId() {
      this.loadDetail()
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    invoiceStateText,
    formatInvoiceLineAmount,
    loadDetail() {
      if (this.rowData) {
        this.info = { ...this.rowData }
        return
      }
      if (!this.rowId) {
        this.info = null
        return
      }
      invoiceApplicationAuditApi
        .fetchDetail(this.rowId)
        .then(res => {
          const data = res && (res.data || res)
          this.info = data || null
        })
        .catch(() => {
          this.info = null
        })
    },
    getStatusText(row) {
      if (row.stateStr) return row.stateStr
      const status = row.state != null ? row.state : (row.auditStatus != null ? row.auditStatus : row.status)
      const map = { 0: '待审核', 1: '开票中', 2: '已开票', 3: '用户取消', 4: '开票失败' }
      return map[status] || '待审核'
    },
    getStepActive(step) {
      if (!this.info) return false
      const state = this.info.state != null ? this.info.state : (this.info.auditStatus != null ? this.info.auditStatus : this.info.status)
      const s = Number(state)
      if (step === 1) return s >= 0
      if (step === 2 || step === 3) return s >= 1
      if (step === 4) return s >= 2
      return false
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num
    },
    getProductList(row) {
      if (!row) return []
      return row.goodsList || row.productList || row.itemList || []
    },
    getTotalQuantity(row) {
      if (row && row.goodsCount != null) return row.goodsCount
      const list = this.getProductList(row)
      return list.reduce((sum, item) => sum + (Number(item.goodsCount) != null ? Number(item.goodsCount) : (Number(item.quantity) || 0)), 0)
    },
    getTotalAmount(row) {
      if (row && row.totalPrice != null) return row.totalPrice
      const list = this.getProductList(row)
      return list.reduce((sum, item) => {
        const amt = item.goodsTotalPrice != null ? item.goodsTotalPrice : (item.goodsPrice != null ? item.goodsPrice : (item.invoiceAmount || item.amount))
        return sum + (Number(amt) || 0)
      }, 0)
    },
    handleBack() {
      this.$emit('handleShow')
    },
    handleExport() {
      // BUG-2026-581958：这个 code 必须与后端 downloadCustomerOrderInvoiceList 里
      // dto.setCode(...) 写进 sys_task 的字面量完全一致 —— 它同时决定
      // ①导出中心挂哪个表单组件 ②任务列表按哪个 code 去筛。
      // 原来写的 'InvoiceApplicationAuditExport' 两头都对不上：没有对应组件（页面空白），
      // 也筛不到任务（列表永远为空），而且全程不报错。
      this.$router.push('/export/list?code=downloadCustomerOrderInvoiceList')
    },
    getInvoiceId() {
      if (this.info && this.info.invoiceId != null) return this.info.invoiceId
      if (this.info && this.info.id != null) return this.info.id
      return this.rowId
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  border: none;
  background: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
  border-radius: 0;

  .back-list {
    position: absolute;
    top: 0;
    right: 0;
    width: 74px;
    height:37px;
    color:#ffffff;
    background: #1596CD;
    border-radius: 0 16px 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
  }

  .common-box {
    padding: 20px;
    background: #fff;
    border-radius: 16px;

    .section-title {
      font-size: 20px;
      font-weight: 500;
      padding: 15px 0;
    }

    .common-title {
      font-size: 16px;
      font-weight: 500;
      position: relative;
      padding-bottom: 20px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: -15px;
        right: -15px;
        height: 1px;
        background: #E5E5E5;
      }
    }
  }

  .order-info {
    .status-bar {
      color: #000000;
      font-size: 14px;
      gap: 50px;

      .status-value {
        color: #1596CD;
      }

      .amount-value {
        color: #E73F3F;
      }
    }

    .applicant-info {
      display: flex;
      gap: 14px;
      flex-wrap: wrap;

      .detail-item {
        width: 40%;
        color: #6C6C6C;
        font-size: 16px;
      }
    }
  }

  .workflow-steps {
    display: flex;
    gap: 10px;
    flex: 1;
    align-items: flex-start;

    .step-item {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1;
      position: relative;
      justify-content: center;
      flex-direction: column;

      .item-icon {
        width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 1px solid #8f8e8e;

        img {
          width: 28px;
          height: 28px;
        }
      }

      .item-title {
        font-size: 16px;
        color: #000000;
      }

      .item-description {
        font-size: 14px;
        color: #666666;
      }

      &.active {
        .item-icon {
          background: #E73F3F;
          border: 1px solid #E73F3F;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 20px;
        width: calc(50%);
        right: calc(50% + 44px);
        height: 1px;
        background: #E5E5E5;
      }

      &::after {
        content: '';
        position: absolute;
        top: 20px;
        width: calc(50% - 44px);
        right: 0;
        height: 1px;
        background: #E5E5E5;
      }

      &:first-child {
        &::before {
          display: none;
        }
      }

      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }

  //发票文件
  .invoice-file {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #E5E5E5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 14px;

    .file-icon {
      width: 52px;
      height: 52px;
      border-radius: 8px;
      background: #E73F3F;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .file-info {
      flex: 1;
      min-width: 0;

      .file-name {
        font-size: 16px;
        color: #2E2F3E;
        font-weight: 500;
        line-height: 1.4;
      }

      .file-tip {
        margin-top: 4px;
        font-size: 12px;
        color: #999;
      }
    }

    .file-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  //开票信息
  .detail-box {
    padding: 20px 2px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .detail-item {
      display: flex;
      width: 28%;
      align-items: center;
      line-height: 30px;
      font-size: 14px;
      color: #2E2F3E;
    }
  }

  //开票订单信息
  .product-table {
    padding-top: 20px;

    .table-summary {
      display: flex;
      padding-top: 30px;
      padding-bottom: 6px;
      justify-content: flex-end;
      gap: 20px;
      font-size: 14px;
      color: #666666;

      .summary-value {
        color: #E73F3F;
      }
    }
  }
}
</style>
